module.exports = __webpack_public_path__ + "img/04.77084b19.jpg";